import { useMutation } from "@apollo/client";
import { globalVariables } from "helper/globalVariables";
import { tickWhite } from "helper/icons";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { UpdateJudgeLevel } from "redux/features/superAdminSlice/manageUsersSlice/manageUsersGql";
import { Button } from "shared/Components/button";
import Dropdown from "shared/Components/dropdown";
import { MultiSelectChipsWithSearchDropdown } from "shared/Components/multiSelectWithSearchAndChips";
import { PopUpMessages } from "shared/Components/popUpMessages";

const Options = [
  globalVariables.novice,
  globalVariables.advanced,
  globalVariables.excellent,
  globalVariables.premier,
  globalVariables.provisional,
];
const JudgeApprovalComponent = ({ defaulLevel }) => {
  const { id } = useParams();
  const [level, setLevel] = useState("");

  const [defaultOptions, setDefaultOptions] = useState([]);

  useEffect(() => {
    console.log("Default Level ", defaulLevel);
    let levelsFetched = defaulLevel.map((data, index) => ({
      label: data,
      value: `option_${index}`,
    }));
    setDefaultOptions(levelsFetched);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const options = Options.map((data, index) => ({
    label: data,
    value: `option_${index}`,
  }));

  const modalRef = useRef();
  const [updateLevel, { loading, data }] = useMutation(UpdateJudgeLevel);

  const onApprove = async () => {
    await updateLevel({
      variables: {
        authId: id,
        level,
      },
    });
    modalRef.current.openModal();
  };

  const handleFilterChange = (selectedOptions) => {
    const selectedValues = selectedOptions.map((option) => option.label);
    setLevel(selectedValues);
  };

  return (
    <div className="rounded-xl bg-white py-4 px-4 flex gap-1 flex-col mt-4">
      <span className="text-xl font-semibold">
        {globalVariables.approveJudge}
      </span>
      <span>{globalVariables.approveJudgeDesc}</span>
      <div className="flex flex-col md:flex-row gap-4 mt-2 pb-[30px]">
        <MultiSelectChipsWithSearchDropdown
          width={
            // "w-[170px] md:w-[160px] lg:w-[302px] max-[380px]:w-[155px] max-[345px]:w-[130px]"
            "w-[170px] lg:min-w-[218px] lg:w-auto md:w-auto md:min-w-[170px]  max-[380px]:w-[155px] max-[345px]:w-[130px]"
          }
          placeholder={globalVariables.level}
          options={options}
          defaultSelectedOptions={defaultOptions}
          useDefault={true}
          label=""
          onChange={handleFilterChange}
        />

        {/* <Dropdown
          width="w-[100%] md:w-[180px]"
          dropdownOptions={Options}
          defaultOption={level}
          placeholder={globalVariables.selectLevel}
          onChange={setLevel}
        /> */}
        <Button
          label={globalVariables.approve}
          width="w-[100%] md:w-[130px]"
          icon={tickWhite}
          onClick={onApprove}
          prefix={false}
          disabled={loading}
        />
      </div>
      <PopUpMessages
        title="Success"
        desc={data?.updateJudgeLevel?.message}
        ref={modalRef}
      />
    </div>
  );
};
export default JudgeApprovalComponent;
